import {creates, hoistCmp} from '@xh/hoist/core';
import {YoyWidgetModel} from './YoyWidgetModel';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {chart} from '@xh/hoist/cmp/chart';
import {widgetToolbar} from '../../../../cmp/widget/WidgetToolbar';
import {widgetToolbarButton} from '../../../../cmp/widget/WidgetToolbarButton';

export const yoyWidget = hoistCmp.factory({
    model: creates(() => YoyWidgetModel),
    render({model}) {
        return panel({
            item: chart(),
            bbar: bbar(),
            mask: 'onLoad'
        });
    }
});

const bbar = hoistCmp.factory<YoyWidgetModel>(({model}) =>
    widgetToolbar({
        items: model.seriesMeta.map(s =>
            widgetToolbarButton({
                key: s.key,
                text: s.name,
                style: {
                    '--widget-toolbar-text-color': s.color,
                    opacity: s.visible ? 1 : 0.4
                } as React.CSSProperties,
                onClick: () => model.toggleSeries(s.key)
            })
        )
    })
);
